import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../components/webform";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Gettouch(props) {
  return (
    <div className="gettouch  p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Conect">
              <h2>Talk to Our App Development Experts</h2>
            </div>
            <p>
              Share your on-demand app development idea or queries, we’ll get
              back to you with a free consultation call.
            </p>
            <h5>Transform Service Offering Strategy</h5>
            <p>
              Collaborate with our on-demand mobile app developers to build
              innovative business solutions.
            </p>
            <div className="connect_awards_main">
              <div className="connect_item_awards">
                <div className="connect_awards_img">
                  <Link
                    to="https://www.goodfirms.co/company/tekrevol"
                    target="_blank"
                  >
                    <StaticImage
                      src="../../images/services-usa/web/goodfrims.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={76}
                      height={61}
                    />
                  </Link>
                </div>
                <div className="connect_awards_content">
                  <h6>5.0</h6>
                  <h6>Goodfirms</h6>
                </div>
              </div>
              <div className="connect_item_awards">
                <div className="connect_awards_img">
                  <Link
                    to="https://www.rightfirms.co/company/tekrevol"
                    target="_blank"
                  >
                    <StaticImage
                      src="../../images/services-usa/web/rightfirms.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={74}
                      height={79}
                    />
                  </Link>
                </div>
                <div className="connect_awards_content">
                  <h6>4.8</h6>
                  <h6>Rightfirms</h6>
                </div>
              </div>
              <div className="connect_item_awards">
                <div className="connect_awards_img">
                  <Link to="https://clutch.co/profile/tekrevol" target="_blank">
                    <StaticImage
                      src="../../images/services-usa/web/clutch_rating.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={72}
                      height={83}
                    />
                  </Link>
                </div>
                <div className="connect_awards_content">
                  <h6>4.8</h6>
                  <h6>Clutch</h6>
                </div>
              </div>
            </div>
            <div className="contact_info_web">
              <h5>Contact Info:</h5>
              <div className="contact_info_item">
                <div className="contact_info_img">
                  <StaticImage
                    src="../../images/services-usa/web/mail.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={25}
                    height={25}
                  />
                </div>
                <div className="contact_info_profile">
                  <Link
                    to="mailto:info@tekrevol.com"
                    aria-label="TekRevol Contact"
                  >
                    info@tekrevol.com
                  </Link>
                </div>
              </div>
              <div className="contact_info_item">
                <div className="contact_info_img">
                  <StaticImage
                    src="../../images/services-usa/web/phone_num.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={25}
                    height={25}
                  />
                </div>
                <div className="contact_info_profile">
                  <Link to="tel:+18003629239" aria-label="TekRevol Contact">
                    +1 800-362-9239
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <ContentFrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
